<div class="command-palette">
  @if (selectionLabel) {
    <div class="command-palette-selection" [attr.title]="selectionLabel">
      {{ selectionLabel }}
    </div>
  }
  <div class="command-palette-header">
    <mat-icon
      class="command-palette-search-icon"
      svgIcon="heroicons_outline:magnifying-glass"
    ></mat-icon>
    <input
      #searchInput
      class="command-palette-input"
      type="text"
      placeholder="Search pages and actions..."
      autocomplete="off"
      spellcheck="false"
      role="combobox"
      aria-autocomplete="list"
      aria-controls="command-palette-list"
      [attr.aria-activedescendant]="activeResultId"
      [attr.aria-expanded]="results.length > 0"
      (input)="onQueryInput($event)"
      (keydown)="onKeydown($event)"
    />
    <span class="command-palette-kbd">Esc</span>
  </div>

  <div #resultList id="command-palette-list" class="command-palette-list" role="listbox">
    @for (group of groups; track group.section) {
      <div class="command-palette-section" role="presentation">{{ group.section }}</div>
      @for (entry of group.entries; track entry.id; let i = $index) {
        <div
          class="command-palette-row"
          role="option"
          [id]="'command-palette-option-' + (group.startIndex + i)"
          [class.is-active]="group.startIndex + i === activeIndex"
          [class.is-disabled]="entry.disabled"
          [attr.aria-selected]="group.startIndex + i === activeIndex"
          [attr.aria-disabled]="entry.disabled || null"
          (mouseenter)="activeIndex = group.startIndex + i"
          (mousedown)="$event.preventDefault()"
          (click)="select(entry)"
        >
          <mat-icon
            class="command-palette-row-icon"
            [svgIcon]="entry.icon ?? 'heroicons_outline:rectangle-stack'"
          ></mat-icon>
          <span class="command-palette-row-text">
            <span class="command-palette-row-title">{{ entry.title }}</span>
            @if (entry.group) {
              <span class="command-palette-row-group">{{ entry.group }}</span>
            }
          </span>
          @if (entry.hint) {
            <span class="command-palette-kbd command-palette-row-hint" [attr.title]="entry.hint">{{ entry.hint }}</span>
          }
          @if (entry.shortcut) {
            <span class="command-palette-kbd command-palette-row-shortcut">{{ entry.shortcut }}</span>
          }
        </div>
      }
    } @empty {
      <div class="command-palette-empty">No matches</div>
    }
  </div>

  <div class="command-palette-footer">
    <span><kbd>↑</kbd><kbd>↓</kbd> move</span>
    <span><kbd>Enter</kbd> run</span>
    @if (hasRecordShortcuts) {
      <span><kbd>1</kbd>–<kbd>9</kbd> selected</span>
    }
    <span><kbd>Esc</kbd> close</span>
  </div>
</div>
